import  backgroundImage from '../src/images/raafat.jpeg'
import  backgroundImage1 from '../src/images/thaer&hana.jpeg'

const weddings = [

{
    groomName: "Thaer",
    brideName : "Hana",
    backgroundImage : backgroundImage1

},{
    groomName: "Raafat",
    brideName : "Donia",
    backgroundImage : backgroundImage

}
]


export default  weddings;